import { memo, useState } from 'react';
import { Grid } from '@mui/material';
import { DateTime } from 'luxon';
import { getDateRange, getDateTime } from '@sda/utils/date';
import { getEventLocation, getRoundedFollowers, pluralize } from '@sda/utils/string';
import { ProfileTypes } from '@sda/enums';
import { ConnectCard } from '../common/ConnectCard';
import type { AlgoliaBeacon, GeolocHit } from '@sda/helpers/algolia.helpers';

interface ConnectCardGroupProps {
  readonly hitSet: GeolocHit<AlgoliaBeacon>[];
  readonly onMouseEnter?: (hoverId?: string) => void;
}

export const ConnectCardGroup = memo<ConnectCardGroupProps>(({ hitSet, onMouseEnter = () => {} }) => {
  const [open, setOpen] = useState(() => {
    const [hit] = hitSet;

    return hit.publicBeacon.profileType === ProfileTypes.VENUE;
  });

  if (!open) {
    const [hit] = hitSet;

    let startDate = getDateTime();
    let endDate = getDateTime();

    hitSet.forEach((item) => {
      startDate = DateTime.min(startDate, getDateTime(item.publicBeacon.startDate));
      endDate = DateTime.max(endDate, getDateTime(item.publicBeacon.endDate));
    });

    return (
      <Grid
        key={hit.objectID}
        xs={12}
        md={6}
        item
      >
        <ConnectCard
          chipLabel={!hit.publicBeacon.isPublicCall && 'Private'}
          imgSrc={hit.publicBeacon.profileData.publicImageUrl}
          title={hit.publicBeacon.profileData.name}
          numReviews={hit.publicBeacon.profileData.numReviews}
          score={hit.publicBeacon.profileData.score}
          dateRange={getDateRange({ startDate, endDate })}
          isFeatured={hit.publicBeacon.isFeatured}
          badge={hit.publicBeacon.profileData.badge}
          spotifyMonthlyActiveListeners={getRoundedFollowers(hit.publicBeacon.profileData.spotifyMonthlyActiveListeners, 'compact')}
          onMouseEnter={() => onMouseEnter(hit.publicBeacon.profileId)}
          onMouseLeave={() => onMouseEnter(null)}
          onClick={() => setOpen(true)}
          location={(
            <u>
              {pluralize('location', hitSet.length)}
            </u>
          )}
        />
      </Grid>
    );
  }

  return hitSet.map((hit) => (
    <Grid
      key={hit.objectID}
      xs={12}
      md={6}
      item
    >
      <ConnectCard
        chipLabel={!hit.publicBeacon.isPublicCall && 'Private'}
        imgSrc={hit.publicBeacon.profileData.publicImageUrl}
        path={`/connect/${hit.objectID}`}
        title={hit.publicBeacon.profileData.name}
        location={getEventLocation(hit.publicBeacon)}
        numReviews={hit.publicBeacon.profileData.numReviews}
        score={hit.publicBeacon.profileData.score}
        dateRange={getDateRange(hit.publicBeacon)}
        isFeatured={hit.publicBeacon.isFeatured}
        badge={hit.publicBeacon.profileData.badge}
        spotifyMonthlyActiveListeners={getRoundedFollowers(hit.publicBeacon.profileData.spotifyMonthlyActiveListeners, 'compact')}
        onMouseEnter={() => onMouseEnter(hit.objectID)}
        onMouseLeave={() => onMouseEnter(null)}
      />
    </Grid>
  ));
});
